import styled from "styled-components";
export {
	SectionAllButton as AllButton,
	SliderArrowButton as ArrowButton,
	SliderArrowIcon as ArrowIcon,
	SliderControls as Controls,
	SectionTitle as TitleBox,
} from "../shared/sliderPrimitives";

export const WRAPPER = styled.section`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	margin-bottom: 24px;

	@media (max-width: 767px) {
		gap: 12px;
		margin-bottom: 14px;
	}
`;

export const HEADER = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
`;

export const Viewport = styled.div`
	overflow: hidden;
	width: 100%;
	container-type: inline-size;
	container-name: betto-provider-viewport;
`;

export const Track = styled.div`
	display: flex;
	flex-wrap: nowrap;
	width: max-content;
	min-width: 100%;
	gap: ${({ $gap }) => `${$gap}px`};
	align-items: stretch;
	transform: translateX(
		calc(
			-1 * ${({ $index }) => $index} * (100cqi + ${({ $gap }) => `${$gap}px`}) / ${({ $count }) => $count}
		)
	);
	transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	will-change: transform;
`;

export const ProviderCard = styled.div`
	flex: 0 0
		calc(
			(100cqi - ${({ $count, $gap }) => `${($count - 1) * $gap}px`}) /
				${({ $count }) => $count}
		);

	aspect-ratio: 196 / 80;
	box-sizing: border-box;
	display: block;
	padding: 0;
	border-radius: 14px;
	background: #171c2a;
	cursor: pointer;
	position: relative;
	overflow: hidden;

	img {
		position: absolute;
		inset: 0;
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: inherit;
	}
`;
